export default __webpack_public_path__ + "recruteur_img.b63a14a.png";